import { FC } from 'react';

import Breadcrumbs from 'molecules/Breadcrumbs';
import Heading from 'molecules/Heading';
import Section from 'molecules/Section';
import { splitSectionProps } from 'molecules/Section/config';

import FeaturedResourceCard from 'organisms/Cards/FeaturedResourceCard';

import { HeroWithFeaturedResourceConfigProps } from 'components/Hero/config';

const HeroFeaturedResource: FC<HeroWithFeaturedResourceConfigProps> = props => {
  const {
    sectionProps,
    rest: { featuredResource, eyebrow, heading, body, buttons, as },
  } = splitSectionProps(props);

  return (
    <Section {...sectionProps}>
      <div className="flex flex-col items-start gap-8 sm:gap-12 lg:gap-14">
        <Breadcrumbs />
        <Heading
          eyebrow={eyebrow}
          heading={heading}
          body={body}
          buttons={buttons}
          alignment="left"
          size="lg"
          as={as || 'h1'}
          animateOnMount
        />
        {featuredResource?.value?.data && <FeaturedResourceCard {...featuredResource.value.data} />}
      </div>
    </Section>
  );
};

export default HeroFeaturedResource;
